import React, { useState, useEffect } from 'react';
import { Button, App, Steps, Tooltip } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getProductDetail } from '@/api/products';
//使用国际化
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from '@/store/hooks';
import icon1 from '@/assets/images/路径 1717.png';
import styles from './index.module.scss';
import StorePublishProductStep1 from './components/StorePublishProductStep1/StorePublishProductStep1';
import StorePublishProductStep2 from './components/StorePublishProductStep2/StorePublishProductStep2';
import StorePublishProductStep3 from './components/StorePublishProductStep3/StorePublishProductStep3';
import StorePublishProductStep4 from './components/StorePublishProductStep4/StorePublishProductStep4';
import { IFormDataAll, ISkuList } from './types';



const StoreEntry: React.FC = () => {
  //国际化语言切换 AI不要删除
  const { t } = useTranslation();

  const { message } = App.useApp();
  //跳转
  const navigate = useNavigate();

  // 获取查询参数
  const [searchParams] = useSearchParams();

  // 当前步骤
  const [currentStep, setCurrentStep] = useState(0);

  //是否独立模式
  const [independent, setIndependent] = useState(true);

  //表单的总数居
  const [formDataAll, setFormDataAll] = useState<IFormDataAll>(

    {
      product_id: "",
      user_id: '',
      status: 1,
      is_delete: false,
      product_category_id: null,
      product_category_brand_id: null,
      product_spu_id: null,
      product_title: "",
      product_content: [],
      product_status: 1,

      // 第二页价格相关
      launch_option: 'schedule',

      // 第三页物流相关
      delivery_estimated_time: '24hours',
      delivery_method: 1,

      product_sku_values: [
        // {
        //   "brand_name": "Apple",
        //   "is_on_shelf": true,
        //   "product_spu_name": "iphone 16 pro max", "product_sku_id": 1, "product_price": 1, "product_stock": 2,
        //   "specs": [{ "lable": "产地", "value": "America", "product_base_attribute_id": 3 }, { "lable": "颜色", "value": "白色", "product_base_attribute_id": 17 }]
        // },

      ],
      product_media_list: [
        // {
        //   "product_id": "201752483170745bdffebf6aa0e",
        //   "product_media_type": "images",
        //   "product_media_file_url": "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        //   "product_media_video_cover_id": null,
        //   "file_id": 7
        // }
      ],

      product_video_list: [
        // {
        //   "product_id": "201752483170745bdffebf6aa0e",
        //   "product_media_type": "images",
        //   "product_media_file_url": "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        //   "product_media_video_cover_id": null,
        //   "file_id": 7
        // }
      ],

      //自定义属性
      product_custom_attributes: [
        // {
        //   "attribute_name": "自定义属性名称1",
        //   "attribute_value": "自定义属性值1"
        // },


      ],
      product_del_media_list: [],
      //自定义SKU属性集合JSON串
      customize_SKU_attribute: ""
    }
  );

  // 编辑的时候获取sku原始列表，不参与sku列表的生成，方便比对不丢失product_sku_id
  const [parentSkuList, setParentSkuList] = useState<ISkuList[]>([
    // {
    //   brand_name: 'Apple',
    //   product_spu_name: 'iphone 16',
    //   product_sku_id: 1,
    //   product_price: 99.0,
    //   product_stock: 20,
    //   specs: [{ lable: '产地', value: 'America', product_base_attribute_id: 3 }],
    //   is_on_shelf: false,
    // },
  ]);

  // 步骤数据
  const steps = [
    {
      title: 'Basic Information',
      description: '',
      status: 'process',
    },
    {
      title: 'Sales Information',
      description: '',
      status: 'wait',
    },
    {
      title: 'Logistics Services',
      description: '',
      status: 'wait',
    },
    {
      title: 'Multimedia Product Listing',
      description: '',
      status: 'wait',
    },
  ];


  // 处理上一步
  const handlePrev = () => {

    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };




  useEffect(() => {
    //编辑获取详情
    const productId = searchParams.get('id');
    //debugger
    if (productId) {
      setIndependent(false);
      getProductDetail({ product_id: productId }).then((res) => {
        console.log(res, 'res');
        if (res.code === 200) {
          res.data.product_category_id =
            res?.data?.product_category?.product_category_id || 0;

          res.data.product_category_brand_id =
            res?.data?.product_category_brand?.product_category_brand_id || 0;

          res.data.product_spu_id =
            res?.data?.product_spu?.product_spu_id || 0;

          // res.product_content =
          // res?.data?.product_content?JSON.parse(res?.data?.product_content) :[];

          setFormDataAll(res.data);
          setParentSkuList(res?.data?.product_sku_values || []);
        }
      });
    }
  }, []);

  return (
    <div className={styles['store-entry']}>
      <h1 className={styles['page-title']}>{t('showCase.MultimediaListing')}</h1>
      <div className={styles['entry-container']}>


        {/* 右侧内容区 */}
        <div className={styles['main-content']} style={{padding: '0'}}>
         

          {/* 步骤内容 */}
          <div className={styles['content-container']}>
            <div className={styles['step-content']}>
              {/* 提交成功页面不需要安全提示 */}
              <StorePublishProductStep4
                formData={formDataAll}
                independent={independent}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreEntry; 